export default __webpack_public_path__ + "scripts/resource/4a31964fa07590b97a155b027cc67fdf.svg";